module.exports = __webpack_public_path__ + "img/emoji_chensi.8af9885f.png";